<template src="./produto-item-card.html"></template>
<style lang="less" scoped src="./produto-item-card.less"></style>

<script>
import Card from "@/components/cards/card/card";
import Currency from "@/filters/currency/currency.filter";
import ImagemNaoDisponivel from "@/modules/loja/produto/components/imagem-nao-disponivel/imagem-nao-disponivel";
import BtnAdicionarNoCarrinho from "@/components/buttons/btn-adicionar-no-carrinho/btn-adicionar-no-carrinho";

export default {
  filters: {
    Currency
  },
  components: {
    Card,
    ImagemNaoDisponivel,
    BtnAdicionarNoCarrinho
  },
  props: {
    produto: {
      default: null
    }
  },
  methods: {
    click(ev) {
      this.$emit("click", ev)
    }
  }
}
</script>